import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GuardianPayment.css';

/**
 * PaymentFailed - Displays payment failure message
 * This is the page users are redirected to after failed GoCardless/Nuapay payment
 * Matches Laravel's guardian_pay.payment_failed view
 */
const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <div className="guardian-payment">
      <section style={{ marginTop: '40px' }}>
        <div className="container">
          <div className="panel panel-default panel-standard" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <div className="panel-body text-center" style={{ padding: '40px' }}>
              {/* Error Icon */}
              <div style={{ marginBottom: '30px' }}>
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    backgroundColor: '#dc3545',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </div>
              </div>

              <h2 style={{ color: '#dc3545', marginBottom: '20px' }}>
                Payment Failed
              </h2>

              <p style={{ fontSize: '16px', color: '#555', marginBottom: '30px' }}>
                Unfortunately, your payment could not be processed. This could be due to:
              </p>

              <ul style={{ textAlign: 'left', maxWidth: '400px', margin: '0 auto 30px', color: '#666' }}>
                <li style={{ marginBottom: '10px' }}>Insufficient funds in your account</li>
                <li style={{ marginBottom: '10px' }}>Payment was declined by your bank</li>
                <li style={{ marginBottom: '10px' }}>The payment session expired</li>
                <li style={{ marginBottom: '10px' }}>You cancelled the payment</li>
              </ul>

              <div
                style={{
                  backgroundColor: '#fff3cd',
                  padding: '15px',
                  borderRadius: '8px',
                  marginBottom: '30px',
                  border: '1px solid #ffc107',
                }}
              >
                <p style={{ margin: 0, color: '#856404' }}>
                  <strong>Don't worry!</strong> No money has been taken from your account.
                  You can try again or contact us for assistance.
                </p>
              </div>

              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button
                  onClick={() => window.history.back()}
                  className="btn btn-primary btn-lg"
                >
                  Try Again
                </button>
                <button
                  onClick={() => navigate('/guardian-dashboard')}
                  className="btn btn-outline-secondary btn-lg"
                  style={{ border: '1px solid #ccc' }}
                >
                  Go to Dashboard
                </button>
              </div>

              <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
                <p style={{ color: '#999', fontSize: '12px', marginBottom: '5px' }}>
                  Need help? Contact us at:
                </p>
                <p style={{ color: '#666', fontSize: '14px' }}>
                  <strong>guardiancare@global-guardians.co.uk</strong>
                  <br />
                  +44 (0) 333 200 1010
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PaymentFailed;
